import BCoinImage from '../../../../images/bcoin-logo-animated-v2.gif';
import BCoinBodyLeftCol from '../../components/BCoinBodyLeftCol';
// import CoinWidget from './components/BCoinLogo/BCoinLogo';

const BCoinWhatIsIt = () => (
  <div className='bcoin-body'>
    <BCoinBodyLeftCol
      description='This is our own corporate token, which you can use within the company and exchange for a variety of gifts'
      descriptionClassName='bcoin-what-is-it-description'
      titleClassName='bcoin-what-is-it-title'
      subtitleClassName='bcoin-what-is-it-subtitle'
      subtitle='b-coin'
      title='Meet'
    />
    <div className='bcoin-body-right-col'>
      <div className='right-col-animated'>
        <div className='bcoin-icon-wrapper'>
          <img src={BCoinImage} alt='b-coin' />
        </div>
        {/* <CoinWidget /> */}
      </div>
    </div>
  </div>
);

export default BCoinWhatIsIt;
